import { EMIT_NOTIFICATION } from "@/store/mutations-types";
import { NotificationType } from "@/models/NotificationI";
import { NavigationGuardNext, Route } from "vue-router";
import store from "@/store";
import i18n from "@/plugins/i18n";

/**
 * Some common Route helper functions
 */
export class RouteHelper {
  /**
   * If the edit/moderate form is dirty and the user did not confirm leave,
   * prevent losing unsaved changes by canceling navigation
   */
  static canLeaveAfterSave(
    isDirty: boolean,
    to: Route,
    next: NavigationGuardNext
  ): void {
    if (isDirty && to.name !== "editCPTPreAuth") {
      store.commit(EMIT_NOTIFICATION, {
        type: NotificationType.WARNING,
        title: i18n.t("views.editCPT.unsavedChangesTitle"),
        text: i18n.t("views.editCPT.unsavedChanges"),
      });
      next(false);
    } else {
      // Navigate to next view
      next();
    }
  }
}
